var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_110_4779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106 53.0002C106 69.8094 98.1752 84.7907 85.9688 94.5C76.9198 101.7 65.4643 106 53.0002 106C40.5361 106 29.0807 101.7 20.0312 94.5C7.82528 84.7907 0 69.8094 0 53.0002C0 23.7295 23.73 0 53.0002 0C82.2705 0 106 23.7295 106 53.0002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9996 73.1964C64.3756 73.1964 73.5978 63.9743 73.5978 52.5982C73.5978 41.2221 64.3756 32 52.9996 32C41.6235 32 32.4014 41.2221 32.4014 52.5982C32.4014 63.9743 41.6235 73.1964 52.9996 73.1964Z",
    fill: "#EEEEEE",
    fillOpacity: 0.933333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9688 94.4998C76.9198 101.7 65.4644 106 53.0003 106C40.5362 106 29.0808 101.7 20.0312 94.4998C26.6578 84.7649 38.9425 78.2271 53.0003 78.2271C67.0581 78.2271 79.3438 84.7634 85.9688 94.4998Z",
    fill: "#EEEEEE",
    fillOpacity: 0.933333
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_110_4779"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 106,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/default-avatar.8d29b8b8176f079afd30461cdb04df8c.svg";
export { ForwardRef as ReactComponent };